"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME = exports.Web3AuthCore = void 0;
/**
 * Re-exporting the ethers package to be used by leap-evm-js consumers.
 * It contains types and all the classes, interfaces that ethers has implemented.
 * Most of which will be replaced by leap-evm-js own implementation in near future.
 */
__exportStar(require("ethers"), exports);
/**
 * Re-exporting the web3auth/ramper package methods to be used by leap-evm-js consumers.
 * It contains types and all the classes, interfaces that web3auth/ramper has implemented.
 * Most of which will be replaced by leap-evm-js own implementation in near future.
 */
var core_1 = require("@web3auth/core");
Object.defineProperty(exports, "Web3AuthCore", { enumerable: true, get: function () { return core_1.Web3AuthCore; } });
__exportStar(require("@web3auth/base"), exports);
var ethereum_1 = require("@ramper/ethereum");
Object.defineProperty(exports, "THEME", { enumerable: true, get: function () { return ethereum_1.THEME; } });
